import "normalize.css"
import "./src/styles/global.css"
import "./src/styles/fonts.css"
// import "prismjs/themes/prism.css"
// import "prismjs/themes/prism-coy.min.css"
import "./src/styles/my-prism-theme.css"
// import { startFullStory } from './src/components/fullStory' // suggested by ChatGPT
//import './src/components/fullStory'

// gatsby-browser.js
export const shouldUpdateScroll = ({
    routerProps: { location },
    prevRouterProps,
    getSavedScrollPosition,
  }) => {
    //console.log("prevRouterProps: ", prevRouterProps)
    // Check if we're navigating to another page
    if (prevRouterProps) {
        // console.log("location.pathname: ", location.pathname)
        // console.log("prevRouterProps.location.pathnam: ", prevRouterProps.location.pathnam)

      // Check if it's a same-page navigation (hash change)
      if (location.pathname === prevRouterProps.location.pathname) {
        // Same page navigation (hash change), don't scroll to top
        //console.log("Same page navigation (hash change), don't scroll to top")
        // return false; 
        //console.log("Let the browser handle scrolling to the hash")
        return true;
      }
  
      //console.log("location.action: ", location.action)
      // Different page navigation
      if (location.action === 'PUSH') {
        // Delay scrolling to top to ensure the page has rendered
        //console.log("Delay scrolling to top to ensure the page has rendered")
        window.setTimeout(() => window.scrollTo(0, 0), 50);
      } else {
        // Use the saved scroll position for back/forward navigation
        //console.log("Use the saved scroll position for back/forward navigation")
        const savedPosition = getSavedScrollPosition(location);
        //console.log("savedPosition: ", savedPosition)
        if (savedPosition) {
          window.setTimeout(() => window.scrollTo(...savedPosition), 50);
        } else {
          window.setTimeout(() => window.scrollTo(0, 0), 50);
        }
      }
    } else {
      // Direct URL navigation (e.g., from an external link or refreshing the page)
      // Let the browser handle scrolling to the hash
      //console.log("Let the browser handle scrolling to the hash")
      return true;
    }
  
    //console.log("the end")
    return false;
};

// suggested by ChatGPT
// export const onRouteUpdate = () => {
//   // Initialize FullStory when route updates
//   startFullStory();
// };

// this is OK, but page scrolls to top when open page with hash
// export const shouldUpdateScroll = ({
//     routerProps: { location },
//     prevRouterProps,
//     getSavedScrollPosition,
//   }) => {
//     // Check if we're navigating to another page or just changing hash on the same page
//     if (prevRouterProps && location.pathname === prevRouterProps.location.pathname) {
//       // Same page navigation (hash change), don't scroll to top
//       return false;
//     }
  
//     // Different page navigation
//     if (location.action === 'PUSH') {
//       window.setTimeout(() => window.scrollTo(0, 0), 50);
//     } else {
//       const savedPosition = getSavedScrollPosition(location);
//       window.setTimeout(() => window.scrollTo(...(savedPosition || [0, 0])), 50);
//     }
  
//     return false;
// };
  


  

